import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'

export const selectQueryFilter = (store: StoreSchema) => store.licenses.queryFilter
